var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBikLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 24,
    viewBox: "0 0 92 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 525"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22 22H2V8.66667L12 2L22 8.66667V22Z",
    fill: "url(#paint0_linear_6463_33429)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M44.2 12.833C43.15 11.9997 41.5166 11.5247 39.3 11.5247H33.6666V9.07467H44.6083V5.33301H28.6666V21.9997H39.2666C41.4888 21.9997 43.125 21.5247 44.175 20.5747C44.7191 20.0678 45.1452 19.4475 45.4232 18.7578C45.7011 18.068 45.824 17.3256 45.7833 16.583C45.8241 15.8784 45.7026 15.1739 45.4281 14.5237C45.1536 13.8735 44.7334 13.2951 44.2 12.833ZM40.1833 18.258C39.5528 18.6866 38.7922 18.8812 38.0333 18.808H33.6666V14.4997H38.0416C38.8057 14.4226 39.5713 14.6303 40.1916 15.083C40.4001 15.2869 40.5629 15.5327 40.6692 15.8042C40.7755 16.0758 40.8229 16.3668 40.8083 16.658C40.8266 16.9541 40.7802 17.2506 40.6722 17.5269C40.5643 17.8033 40.3974 18.0527 40.1833 18.258Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M53.1252 15.008C52.9835 15.1997 52.8836 15.3413 52.8169 15.4497L52.6502 15.7247H52.6002V5.33301H47.6002V21.9997H53.0502L60.3335 12.1663C60.4752 11.9663 60.5752 11.808 60.6419 11.6997L60.8169 11.3663V11.683C60.8169 11.783 60.8169 11.958 60.8169 12.2163V21.9997H65.8169V5.33301H60.3335L53.1252 15.008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M82.0918 21.9997H88.6668L79.8251 13.183L88.0501 5.33301H81.7335L75.4085 11.458H73.6168V5.33301H68.6251V21.9997H73.6168V15.4747H75.4918L82.0918 21.9997Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6463_33429",
    x1: 2,
    y1: 2,
    x2: 22,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0666667,
    stopColor: "#00CBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133333,
    stopColor: "#00CACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#00C6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266667,
    stopColor: "#00C2CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#00BCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00B5CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466667,
    stopColor: "#00AECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533333,
    stopColor: "#00A6CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#009FCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#0098CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733333,
    stopColor: "#0092CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#008ECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866667,
    stopColor: "#008ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933333,
    stopColor: "#0089CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0088CC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBikLogo);
export default __webpack_public_path__ + "static/media/bikLogo.b8458b3dafdb935e03efda920e8624c0.svg";
export { ForwardRef as ReactComponent };